import React from 'react';
import { useState } from 'react';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Table,
} from 'reactstrap';
import { createUseStyles } from 'react-jss';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';
import { get, map, find, toNumber, sortBy } from 'lodash-es';
import { differenceInSeconds } from 'date-fns';
import { Spinner } from 'reactstrap';
import EditChargerModal from '../../components/Modals/EditCharger';
import DisableChargerConfirmationModal from '../../components/Modals/DisableChargerConfirmationModal';
/* import { useMutation, useQueryClient } from 'react-query';
import { editCharger } from '../../utils/queries/hostQueries';
import { toast } from 'react-toastify'; */
import Connector from '../../components/Connector';
import ChargerOnMap from '../../components/Charger/ChargerOnMap';

//Queries
import { useHostChargerDetails } from '../../utils/queries/hostQueries';

//Charts
import EnergyDeliveredByGranularityBarChart from '../../components/Charts/Charger/EnergyDeliveredBarChartByGranularity';
import ChargingTimeByGranularityBarChart from '../../components/Charts/Charger/ChargingTimeBarChartByGranularity';
import ChargingSessionsByGranularityBarChart from '../../components/Charts/Charger/ChargingSessionsCompletedByGranularity';

import {
  generateGranularityBasedDateRange,
  // vehicleTypes,
  localDate,
} from '../../utils/misc';
import { capitalize } from 'lodash';
import { getLocalDateInFormat } from 'utils/dateFormatter';
import { Tag } from 'antd';
import { ChargingSessionsGridHost } from 'components/Reusable/ChargingSessionsGridHost';
import { useEffect } from 'react';
import moment from 'moment';

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  chargerStatus: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
  },
  connectionUrl: { marginLeft: '10px' },
  disableButton: {
    backgroundColor: '#2675b8',
    width: '150px',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
  },
  enableButton: {
    backgroundColor: '#2675b8',
    width: '150px',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
  },
  onlineStatus: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#28a745',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  offlineStatus: {
    backgroundColor: '#e61b1b',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#e61b1b',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
});

const ChargerById = () => {
  const classes = useStyles();
  const { cpid } = useParams();

  // const [hostGranDates, setHostGranDates] = useState(generateGranularityBasedDateRange(granularityEnergySold))

  // useState({
  //   startDate: '',
  //   endDate: '',
  // });

  //const queryQlient = useQueryClient();
  //const { mutateAsync: updateCharger } = useMutation(editCharger);

  const { data: charger, isLoading, error } = useHostChargerDetails(cpid);

  //Edit Charger Modal states

  const [editChargerModalOpen, setEditChargerModalOpen] = useState(false);
  const toggleEditChargerModal = () =>
    setEditChargerModalOpen(!editChargerModalOpen);

  /* ---------------------- */

  /* ------Disable Charger Modal States */
  const [disableChargerModalOpen, setDisableChargerModalOpen] = useState(false);
  const toggleDisableChargerModal = () =>
    setDisableChargerModalOpen(!disableChargerModalOpen);
  /* --------------------------------- */

  function isChargerOnline() {
    const { LAST_HEARTBEAT } = charger;
    let chargerConfig = {};
    if (get(charger, 'CHARGER_CONFIGURATION')) {
      chargerConfig = JSON.parse(get(charger, 'CHARGER_CONFIGURATION'));
    }

    const chargerHearBeatConfigObj = find(
      get(chargerConfig, 'configurationKey'),
      { key: 'HeartbeatInterval' },
    );
    const chargerHeartBeatInterval = toNumber(
      get(chargerHearBeatConfigObj, 'value'),
    );
    const diffInSeconds = differenceInSeconds(
      new Date(),
      new Date(LAST_HEARTBEAT),
    );
    return diffInSeconds <= chargerHeartBeatInterval;
  }

  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [granularityEnergySold, setGranularityEnergySold] =
    useState('last_10_days');
  const [granularityChargingTime, setGranularityChargingTime] =
    useState('last_10_days');
  const [
    granularityChargingSessionsCompleted,
    setGranularityChargingSessionsCompleted,
  ] = useState('last_10_days');

  const [hostGranDates, setHostGranDates] = useState(
    generateGranularityBasedDateRange(granularityEnergySold),
  );

  useEffect(() => {
    const hostGranularities = [
      granularityEnergySold,
      granularityChargingTime,
      granularityChargingSessionsCompleted,
    ];
    if (activeTab > 0) {
      setHostGranDates(
        generateGranularityBasedDateRange(hostGranularities[activeTab - 1]),
      );
    }
  }, [
    activeTab,
    granularityEnergySold,
    granularityChargingTime,
    granularityChargingSessionsCompleted,
  ]);

  //Actually update the charger
  /* const [enablingCharger, setEnablingCharger] = useState(false);
  async function enableCharger() {
    try {
      setEnablingCharger(true);
      const formattedValues = {
        ID: charger.ID,
        IS_ENABLED: 1,
      };
      const updatedCharger = await updateCharger(formattedValues);
      queryQlient.setQueryData('host/chargers', (oldData) => {
        const newMutatedData = map(oldData, (data) => {
          if (data.ID === charger.ID) {
            return updatedCharger;
          } else {
            return data;
          }
        });
        return newMutatedData;
      });
      queryQlient.setQueryData(['host/charger', charger.ID], (oldData) => {
        return updatedCharger;
      });
      queryQlient.fetchQuery(['host/charger', charger.ID]);
      queryQlient.fetchQuery('host/chargers');
      toast.dark('Charger Enabled.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.log(error);
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setEnablingCharger(false);
  } */

  const getSuffixPrefixOfComission = (commissionType, value) => {
    let response = '';
    if (commissionType === 'PERCENTAGE') {
      response = `${value}%`;
    } else if (commissionType === 'FIXED') {
      response = `₹${value}`;
    }
    return response;
  };

  // function displayVehicleType() {
  //   const supportedVehicleType = get(charger, 'VEHICLE_TYPE').trim();
  //   const vehicleTypeObj = find(vehicleTypes, (type) => {
  //     return type.id === supportedVehicleType;
  //   });
  //   return vehicleTypeObj;
  // }

  if (error) {
    <div>Oops something went wrong!</div>;
  }

  const getStartEndDateOfBar = (granularity, label) => {
    if (!label) return;
    let startDate = '';
    let endDate = '';
    if (granularity === 'last_10_days') {
      startDate = label;
      endDate = label;
    } else if (granularity === 'monthly') {
      startDate = moment(`01 ${label}`).startOf('month').format('DD-MM-YYYY');
      endDate = moment(`01 ${label}`).endOf('month').format('DD-MM-YYYY');
    } else if (granularity === 'yearly') {
      startDate = moment(`01-01-${label}`).startOf('year').format('DD-MM-YYYY');
      endDate =
        moment().format('YYYY') === label
          ? moment().format('DD-MM-YYYY')
          : moment(`01-01-${label}`).endOf('year').format('DD-MM-YYYY');
    }
    setHostGranDates({ startDate, endDate });
  };
  return (
    <>
      {isLoading ? (
        <Container className="mt--7" fluid>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
            }}
          >
            <Spinner style={{ color: '#2675b8' }} />
          </div>
        </Container>
      ) : (
        <Container className="mt-7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    {isChargerOnline() ? (
                      <div className={classes.chargerStatus}>
                        <Button
                          onClick={(e) => e.preventDefault()}
                          size="sm"
                          className={classes.onlineStatus}
                        >
                          Online
                        </Button>
                      </div>
                    ) : (
                      <span className={classes.chargerStatus}>
                        <Button
                          onClick={(e) => e.preventDefault()}
                          size="sm"
                          className={classes.offlineStatus}
                        >
                          Offline
                        </Button>
                      </span>
                    )}
                    <h1 className="mb-0 ml-2">{get(charger, 'NAME')}</h1>
                  </div>
                </CardHeader>
                <CardBody>
                  <div>
                    <Row>
                      <Col xs={12} sm={12} lg={8} md={8}>
                        <div className="pl-lg-4">
                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted"
                                >
                                  Charger ID
                                </h4>
                                <h3 className="text">{get(charger, 'ID')}</h3>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Name
                                </h4>
                                <h3 className="text">{get(charger, 'NAME')}</h3>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center1',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted"
                                >
                                  Address
                                </h4>
                                <h3 className="text">
                                  {get(charger, 'ADDRESS')} (
                                  {get(charger, 'LATITUDE')},{' '}
                                  {get(charger, 'LONGITUDE')})
                                </h3>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Type
                                </h4>
                                <h3 className="text">
                                  {get(charger, 'IS_DC') === 0 ? 'AC' : 'DC'}
                                </h3>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Capacity
                                </h4>
                                <h3 className="text">
                                  {get(charger, 'ENERGY')} KW
                                </h3>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Timing
                                </h4>
                                <h3 className="text">
                                  {get(charger, 'TIMING')}
                                </h3>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Tariff
                                </h4>
                                <h3 className="text">
                                  ₹ {get(charger, 'BASE_KWH_COST')}
                                </h3>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Created on
                                </h4>
                                <h3 className="text">
                                  {localDate(get(charger, 'CREATED_AT'))}
                                </h3>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <h4
                                  style={{
                                    marginRight: '40px',
                                    width: '100px',
                                  }}
                                  className="text-muted "
                                >
                                  Modified on
                                </h4>
                                <h3 className="text">
                                  {localDate(get(charger, 'CREATED_AT'))}
                                </h3>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={12} lg={4} md={4}>
                        <ChargerOnMap
                          cpid={null}
                          longitude={charger?.LONGITUDE}
                          latitude={charger?.LATITUDE}
                        />
                      </Col>
                    </Row>
                  </div>

                  <hr className="my-4" />
                  {/* Connectors */}
                  <div className="pl-lg-4">
                    <h3>Connectors</h3>
                    <div style={{ display: 'flex', marginTop: '10px' }}>
                      {map(
                        sortBy(get(charger, 'CP_CONNECTORS'), ['CONNECTOR_ID']),
                        (conn, c) => (
                          <Connector
                            key={conn.CONNECTOR_ID}
                            connectorId={conn.CONNECTOR_ID}
                            type={conn.TYPE}
                          />
                        ),
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card className=" shadow mt-4">
                <CardHeader className="bg-white border-0 pb-0">
                  <h3>Partner Type</h3>
                </CardHeader>
                <CardBody>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Partner Type</th>
                        <th scope="col">Status</th>
                        <th scope="col">Start/ End Date</th>
                        <th scope="col">Commission Type</th>
                        <th scope="col">Commission/Unit</th>
                      </tr>
                    </thead>
                    {isLoading ? null : (
                      <tbody>
                        {map(get(charger, 'JP_CHARGER_COMMISSION'), (cp, c) => (
                          <tr key={c}>
                            <td>
                              {capitalize(cp.PARTNER_TYPE.replace(/_/g, ' '))}
                            </td>
                            <td>
                              <Tag color={cp?.IS_ACTIVE ? 'green' : 'orange'}>
                                {cp?.IS_ACTIVE ? 'Active' : 'Inactive'}
                              </Tag>
                            </td>
                            <td>{`${getLocalDateInFormat(
                              cp.AFFECTIVE_DT,
                            )} to ${getLocalDateInFormat(cp.END_DATE)}`}</td>
                            <td>{capitalize(cp.COMMISSION_TYPE)}</td>
                            <td>
                              {`${getSuffixPrefixOfComission(
                                cp?.COMMISSION_TYPE,
                                cp.COMMISSION,
                              )}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col className="order-xl-1" xl="12">
              <div>
                <Nav tabs>
                  <NavItem style={{ cursor: 'pointer' }}>
                    <NavLink
                      className={classnames({
                        active: activeTab === '1',
                      })}
                      style={{
                        padding: '10px',
                        backgroundColor:
                          activeTab === '1' ? '#2675b8' : 'transparent',
                        color: activeTab === '1' ? 'white' : 'black',
                        border:
                          activeTab === '1' ? 'none' : '1px solid #e4e8ec',
                        borderTopRightRadius: '0px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                      }}
                      onClick={() => {
                        toggle('1');
                      }}
                    >
                      Energy Sold
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ cursor: 'pointer' }}>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        toggle('2');
                      }}
                      style={{
                        padding: '10px',
                        backgroundColor:
                          activeTab === '2' ? '#2675b8' : 'transparent',
                        color: activeTab === '2' ? 'white' : 'black',
                        border:
                          activeTab === '2' ? 'none' : '1px solid #e4e8ec',
                        borderTopRightRadius: '0px',
                        borderTopLeftRadius: '0px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                      }}
                    >
                      Charging Duration
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ cursor: 'pointer' }}>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => {
                        toggle('3');
                      }}
                      style={{
                        padding: '10px',
                        backgroundColor:
                          activeTab === '3' ? '#2675b8' : 'transparent',
                        color: activeTab === '3' ? 'white' : 'black',
                        border:
                          activeTab === '3' ? 'none' : '1px solid #e4e8ec',
                        borderTopLeftRadius: '0px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                      }}
                    >
                      Charging Sessions
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={activeTab}
                  style={{
                    padding: '10px',
                    backgroundColor: 'white',
                    borderRadius: '0px 0px 7px 7px',
                    boxShadow: '0 0 2rem 0 rgb(136 152 170 / 15%)',
                    height: '550px',
                  }}
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col
                        sm="12"
                        md="12"
                        lg="12"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        className="mt-3"
                      >
                        <div className="px-3 mt--1">
                          <h2 className="text mb-0">Energy Sold</h2>
                          <p className="text mb-0" style={{ fontWeight: 500 }}>
                            {
                              generateGranularityBasedDateRange(
                                granularityEnergySold,
                              ).startDate
                            }{' '}
                            -{' '}
                            {
                              generateGranularityBasedDateRange(
                                granularityEnergySold,
                              ).endDate
                            }
                          </p>
                        </div>

                        <div className="px-3">
                          <Nav className="justify-content-end" pills>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active: granularityEnergySold === 'yearly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityEnergySold === 'yearly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityEnergySold === 'yearly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityEnergySold === 'yearly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityEnergySold('yearly');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Year
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active: granularityEnergySold === 'monthly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityEnergySold === 'monthly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityEnergySold === 'monthly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityEnergySold === 'monthly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityEnergySold('monthly');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Monthly
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active:
                                    granularityEnergySold === 'last_10_days',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityEnergySold === 'last_10_days'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityEnergySold === 'last_10_days'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityEnergySold === 'last_10_days'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                data-toggle="tab"
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityEnergySold('last_10_days');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Last 10 days
                                </span>
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </Col>
                      <Col>
                        <div
                          className="chart mt-4 px-3"
                          style={{ paddingBottom: '20px' }}
                        >
                          <EnergyDeliveredByGranularityBarChart
                            granularity={granularityEnergySold}
                            handleBarClick={getStartEndDateOfBar}
                            cpid={cpid}
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col
                        sm="12"
                        md="12"
                        lg="12"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        className="mt-3"
                      >
                        <div className="px-3 mt--1">
                          <h2 className="text mb-0">Charging Duration</h2>
                          <p className="text mb-0" style={{ fontWeight: 500 }}>
                            {
                              generateGranularityBasedDateRange(
                                granularityChargingTime,
                              ).startDate
                            }{' '}
                            -{' '}
                            {
                              generateGranularityBasedDateRange(
                                granularityChargingTime,
                              ).endDate
                            }
                          </p>
                        </div>
                        <div className="px-3">
                          <Nav className="justify-content-end" pills>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active: granularityChargingTime === 'yearly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingTime === 'yearly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingTime === 'yearly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingTime === 'yearly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingTime('yearly');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Year
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active: granularityChargingTime === 'monthly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingTime === 'monthly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingTime === 'monthly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingTime === 'monthly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingTime('monthly');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Monthly
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active:
                                    granularityChargingTime === 'last_10_days',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingTime === 'last_10_days'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingTime === 'last_10_days'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingTime === 'last_10_days'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                data-toggle="tab"
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingTime('last_10_days');
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Last 10 days
                                </span>
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </Col>
                      <Col>
                        <div className="chart mt-4 px-3">
                          <ChargingTimeByGranularityBarChart
                            granularity={granularityChargingTime}
                            handleBarClick={getStartEndDateOfBar}
                            cpid={cpid}
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col
                        sm="12"
                        md="12"
                        lg="12"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        className="mt-3"
                      >
                        <div className="px-3 mt--1">
                          <h2 className="text mb-0">Charging Sessions</h2>
                          <p className="text mb-0" style={{ fontWeight: 500 }}>
                            {
                              generateGranularityBasedDateRange(
                                granularityChargingSessionsCompleted,
                              ).startDate
                            }{' '}
                            -{' '}
                            {
                              generateGranularityBasedDateRange(
                                granularityChargingSessionsCompleted,
                              ).endDate
                            }
                          </p>
                        </div>
                        <div className="px-3">
                          <Nav className="justify-content-end" pills>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active:
                                    granularityChargingSessionsCompleted ===
                                    'yearly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingSessionsCompleted ===
                                    'yearly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingSessionsCompleted ===
                                    'yearly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingSessionsCompleted ===
                                    'yearly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingSessionsCompleted(
                                    'yearly',
                                  );
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Year
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active:
                                    granularityChargingSessionsCompleted ===
                                    'monthly',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingSessionsCompleted ===
                                    'monthly'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingSessionsCompleted ===
                                    'monthly'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingSessionsCompleted ===
                                    'monthly'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingSessionsCompleted(
                                    'monthly',
                                  );
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Monthly
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('py-2 px-3', {
                                  active:
                                    granularityChargingSessionsCompleted ===
                                    'last_10_days',
                                })}
                                style={{
                                  cursor: 'pointer',
                                  border:
                                    granularityChargingSessionsCompleted ===
                                    'last_10_days'
                                      ? '1px solid transparent'
                                      : '1px solid #2675b8',
                                  color:
                                    granularityChargingSessionsCompleted ===
                                    'last_10_days'
                                      ? 'white'
                                      : '#2675b8',
                                  backgroundColor:
                                    granularityChargingSessionsCompleted ===
                                    'last_10_days'
                                      ? '#2675b8'
                                      : 'white',
                                }}
                                data-toggle="tab"
                                preventDefault={true}
                                onClick={(e) => {
                                  setGranularityChargingSessionsCompleted(
                                    'last_10_days',
                                  );
                                }}
                              >
                                <span
                                  className="d-none d-md-block"
                                  style={{ cursor: 'pointer' }}
                                >
                                  Last 10 days
                                </span>
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </Col>
                      <Col>
                        <div className="chart mt-4 px-3">
                          <ChargingSessionsByGranularityBarChart
                            granularity={granularityChargingSessionsCompleted}
                            handleBarClick={getStartEndDateOfBar}
                            cpid={cpid}
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
          {/* <Row className="mt-5">
            <Col>
              <ChargerSessions cpid={cpid} />
            </Col>
          </Row> */}
          <ChargingSessionsGridHost
            startDate={hostGranDates.startDate}
            endDate={hostGranDates.endDate}
            cpid={cpid}
          />

          <EditChargerModal
            editChargerModalOpen={editChargerModalOpen}
            toggleEditChargerModalOpen={toggleEditChargerModal}
            charger={charger}
          />
          <DisableChargerConfirmationModal
            charger={charger}
            disableChargerModalOpen={disableChargerModalOpen}
            toggleDisableChargerModalOpen={toggleDisableChargerModal}
          />
        </Container>
      )}
    </>
  );
};

export default ChargerById;
